import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const UsedCarDealer = () => (
  <ReportLayout title="Clerk Used Car Dealer Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="ucd_application/download"
    />
  </ReportLayout>
);

export default UsedCarDealer;
